<template>
  <div class="shipping">
    <FilterForm :fields="searchFields" @submit="search" class="filter" />
    <Form @submitSuccess="getList" ref="form"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">添加快递</AppButton>
    </div>
    <BasicTable
      :tableData="tableData"
      :columns="columns" 
      :total="pageQuery.total"
      :current-page="pageQuery.page"
      @pageChange="pageChange"
      :node="node">
      <template v-slot:shipping_name="{ item }">
        <div><img :src="item.shipping_logo" style="margin-right:15px" />{{ item.shipping_name }}</div>
      </template>
      <template v-slot:is_enable="{ item }">
        <CheckBox v-model="item.is_enable" @change="enableShipping(item)" ></CheckBox>
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { WebsiteService } from '../../service/website.service'
import Form from './formShipping.vue';
const columns = [
  { name: '快递名称', key: 'shipping_name',type: 'custom' },
  { name: '是否启用', key: 'is_enable', type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom'}
];
  export default {
    name: 'shipping',
    components: { Form },
    data() {
      return {
        fields: [],
        tableData: [],
        columns,
        node: [],
        searchVal: '',
        pageQuery: {
          page: 1,
          rows: 10,
          total: 0
        },
        searchFields: [{
          key: 'shipping_name',
          id: '1',
          type: 'input',
          name: '名称',
        }]
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await WebsiteService.getShippingList(this.pageQuery,this.searchVal);
        this.tableData = data.data;
        this.pageQuery.total = data.total
      },
      addMenu() {
        this.$refs.form.open('add',{});
      },
      editMenu(data) {
        this.$refs.form.open('edit', data);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条快递吗？', '删除快递').then(async () => {
          await WebsiteService.delShipping(data.shipping_id)
          this.getList();
        })
      },
      filter() {
        this.getList();
      },
      enableShipping(item) {
          WebsiteService.switchShippingStatus(item.shipping_id, item.is_enable ? 1 : 0);
      },
      async pageChange(index) {
        this.pageQuery.page = index
        const data = await WebsiteService.getShippingList(this.pageQuery,this.searchVal);
        this.tableData = data.data;
      },
      async search(val) {
        if(val) this.searchVal = val
        const data = await WebsiteService.getShippingList(this.pageQuery,val);
        this.tableData = data.data;
        this.pageQuery.total = data.total
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>
<style lang="scss">
.shipping{
  .filter{
    input{
      width: 15vw;
    }
  }
}
.shipping{
        .time.el-form-item{
            clear: both;
            .el-date-editor.el-input{
                width: auto;
            }
        }
        .edui-default .view::after{
            width: 100%;
            height: 100%;
            background: blue;
            border: 0!important;
            box-shadow: none!important;
        }
        .edui-editor-iframeholder,.edui-editor-bottomContainer{
            display: none;
        }
        .edui-toolbar{
            text-align: left;
        }
    }
</style>